import {Model} from "@vuex-orm/core";
import Configuration from "@models/project/Configuration";
import Contact from "@models/project/Contact";

export default class Project extends Model {
  static entity = "projects";

  get selectOption() {
    return {value: this.id, text: this.name};
  }

  static fields() {
    return {
      id: this.attr(null),
      city: this.attr(null).nullable(),
      country: this.attr(null).nullable(),
      country_iso3: this.attr(null).nullable(),
      customer: this.attr(null).nullable(),
      description: this.attr(null).nullable(),
      name: this.attr(null).nullable(),
      number: this.attr(null).nullable(),
      post_code: this.attr(null).nullable(),
      status: this.attr(null).nullable(),
      street: this.attr(null).nullable(),
      user_id: this.attr(null).nullable(),
      useraccess: this.attr(null).nullable(),
      useraccesses: this.attr(null).nullable(),
      updated: this.attr(null).nullable(),

      members: this.attr([]),
      contact: this.hasOne(Contact, "project_id"),
      configurations: this.hasMany(Configuration, "project_id"),
      selectedProject: this.boolean(false),
    };
  }
}
